import * as React from 'react';
import { Route, Switch } from 'react-router';
import { SupportEmails } from './SupportEmails';
import { SupportThread } from './SupportThread';
export const SupportEmailsRouting = allProps => (
  <Switch>
    <Route exact path="/supportEmails" render={props => <SupportEmails {...props} user={allProps.user} />} />
    <Route exact path="/supportEmails/:threadId" render={props => <SupportThread {...props} user={allProps.user} />} />
  </Switch>
);
SupportEmailsRouting.displayName = 'SupportEmailsRouting';
